import React, { useEffect } from "react";

const CLIENT = process.env.REACT_APP_ADSENSE_CLIENT;

// Renders a Google AdSense unit. Stays invisible until a publisher ID is set,
// so the app never shows an empty/broken ad box before approval.
export default function AdSlot({ slot, className = "" }) {
  useEffect(() => {
    if (!CLIENT) return;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      /* adsbygoogle not ready yet */
    }
  }, []);

  if (!CLIENT || !slot) return null;

  return (
    <div className={className} data-testid="ad-slot">
      <p className="mb-1 text-center text-[10px] uppercase tracking-widest text-zinc-700">
        Advertisement
      </p>
      <ins
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-client={CLIENT}
        data-ad-slot={slot}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
}
